import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mission",
  "use": "icon-mission-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-mission\"><path xmlns=\"http://www.w3.org/2000/svg\" class=\"st0\" d=\"M1020.3 367.7s28.3-113.4-85-113.4c0 0-56.7 0-85 85 0 0-56.7 141.7-170 141.7 0 0-113.4-453.4-680.2-368.4 0 0 141.7 113.4 113.4 255.1 0 0-28.3 226.7 283.4 283.4 0 0-56.7 170-283.4 170 0 0 311.7 226.7 623.5 0 0 0 198.4-141.7 141.7-311.7 0 0 0-56.7 28.3-85-.1 0 141.6 0 113.3-56.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol